module.exports = __webpack_public_path__ + "static/media/devops-icon.9289535e.svg";